/** Shared legal page metadata. */
export const LEGAL_LAST_UPDATED = 'June 12, 2026';

/** Public support contact for legal and privacy inquiries. */
export const SUPPORT_EMAIL = 'support@scoutlytics.gg';
